import React from 'react';

const FormatListNumbered = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.83317 10.8333V9.16666H17.4998V10.8333H5.83317ZM5.83317 15.8333V14.1667H17.4998V15.8333H5.83317ZM5.83317 5.83333V4.16666H17.4998V5.83333H5.83317ZM2.49984 6.66666V4.16666H1.6665V3.33333H3.33317V6.66666H2.49984ZM1.6665 14.1667V13.3333H4.1665V16.6667H1.6665V15.8333H3.33317V15.4167H2.49984V14.5833H3.33317V14.1667H1.6665ZM3.5415 8.33333C3.70726 8.33333 3.86624 8.39918 3.98345 8.51639C4.10066 8.6336 4.1665 8.79257 4.1665 8.95833C4.1665 9.12499 4.09984 9.28333 3.9915 9.39166L2.59984 10.8333H4.1665V11.6667H1.6665V10.9L3.33317 9.16666H1.6665V8.33333H3.5415Z" />
  </svg>
);

export default FormatListNumbered;
